module.exports = __webpack_public_path__ + "media/images/shield_black-fe66a73e.png";